// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ownership-filter-and-warnings-container {
  display: flex;
  justify-content: space-between;
}
.ownership-filter-and-warnings-container .ownership-filter-container {
  padding: 5px;
  margin-right: 10px;
}
.ownership-filter-and-warnings-container .ownership-filter-container .ownership-filter-range {
  display: flex;
  align-items: center;
}
.ownership-filter-and-warnings-container .ownership-filter-container .ownership-filter-range .ownership-left-label {
  margin-right: 5px;
}
.ownership-filter-and-warnings-container .ownership-filter-container .ownership-filter-range .ownership-right-label {
  margin-left: 5px;
}
.ownership-filter-and-warnings-container .ownership-filter-container .ownership-filter-range .ownership-input {
  padding: 0;
}
.ownership-filter-and-warnings-container .ownership-warnings-container {
  padding: 5px;
}
.ownership-filter-and-warnings-container .ownership-warnings-container p {
  margin: 0;
  padding: 0;
}
.ownership-filter-and-warnings-container .ownership-warnings-container p.ownership-warning {
  color: #FB8C3D;
  font-size: 14px;
  padding-left: 10px;
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/styles/ownershipStructure.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;AADF;AAIE;EACE,YAAA;EACA,kBAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;AAFN;AAIM;EACE,iBAAA;AAFR;AAKM;EACE,gBAAA;AAHR;AAMM;EACE,UAAA;AAJR;AAUE;EACE,YAAA;AARJ;AAUI;EACE,SAAA;EACA,UAAA;AARN;AAUM;EACE,cC/BM;EDgCN,eAAA;EACA,kBAAA;EACA,kBAAA;AARR","sourcesContent":["@import './colors';\n\n.ownership-filter-and-warnings-container {\n  display: flex;\n  justify-content: space-between;\n\n  // Filter styling\n  .ownership-filter-container {\n    padding: 5px;\n    margin-right: 10px;\n\n    .ownership-filter-range {\n      display: flex;\n      align-items: center;\n\n      .ownership-left-label {\n        margin-right: 5px;\n      }\n\n      .ownership-right-label {\n        margin-left: 5px;\n      }\n\n      .ownership-input {\n        padding: 0;\n      }\n    }\n  }\n\n  // Warnings container\n  .ownership-warnings-container {\n    padding: 5px;\n\n    p {\n      margin: 0;\n      padding: 0;\n\n      &.ownership-warning {\n        color: $color-orange;\n        font-size: 14px;\n        padding-left: 10px;\n        margin-bottom: 5px;\n      }\n    }\n  }\n}\n","$color-white: #ffffff;\n$color-black: #000000;\n$color-green:#11BC97;\n$color-secGreen:#0ead8a;\n$color-blue:#2091E9;\n$color-sharpGreen:#01FFCA;\n$color-pink:#E66A8B;\n$color-orange:#FB8C3D;\n$color-orange-high:#F4B717;\n$color-yellow:#FB8C3D;\n$color-purple:#A001FF;\n$color-light-purple:#7879F1;\n$color-darkBlue:#110133;\n$color-lightGrey:#F4F6FA;\n$color-normalGrey:#E4E7F0;\n$color-monoDullGrey:#A7B2CD;\n$color-monoNormalGrey:#636A7D;\n$color-light-blue:#a7b2cd;\n$color-monoIntenseGrey:#222735;\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
